import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign(Object.assign({}, getTestId('PageHeaderWidgetContainer')), {
  showLeftArrowIcon: true,
  title: 'Title',
  subtitle: 'Subtitle',
  infoTagProps: {
    text: 'text',
    iconPosition: 'left',
    iconName: 'AirtelIcon',
    subType: 'default'
  },
  leftCtaProps: {
    buttonType: 'primary',
    title: 'primary',
    showLoader: false,
    loaderPosition: 'left',
    disabled: false,
    isUpperCase: true,
    iconName: 'AirtelStoreIcon',
    iconPosition: 'right'
  },
  rightCtaProps: {
    buttonType: 'secondary',
    title: 'secondary',
    showLoader: false,
    loaderPosition: 'right',
    disabled: false,
    isUpperCase: false,
    iconName: 'AirtelFilledIcon',
    iconPosition: 'left'
  },
  actionIconsProps: [{
    iconName: 'NotificationsOnIcon'
  }, {
    iconName: 'NotificationsOnIcon'
  }, {
    iconName: 'MoreIcon',
    onActionIconPress: {
      id: '',
      actions: []
    }
  }],
  breadcrumbWidgetProps: {
    data: [{
      text: 'google',
      disabled: false,
      hyperLinkProps: {
        href: 'https://www.google.com/'
      },
      isHyperLink: true
    }, {
      text: 'airtel',
      disabled: false,
      hyperLinkProps: {
        href: 'https://www.airtel.in/'
      },
      isHyperLink: true
    }, {
      text: 'bing',
      disabled: true,
      hyperLinkProps: {
        href: 'https://www.bing.com/'
      },
      isHyperLink: false
    }, {
      text: 'Parent page',
      disabled: false
    }],
    maxDisplayedItems: 4,
    overflowIndex: 2,
    spacerProps: {
      top: {
        mobile: 'SPACING_8',
        desktop: 'SPACING_8'
      }
    }
  }
});